// extracted by mini-css-extract-plugin
module.exports = {"btn":"popover_btn__qjYe9","btn--default":"popover_btn--default__IOvKA","btn--dark":"popover_btn--dark__ywnS9","btn--outline":"popover_btn--outline__CAFke"};